<script>
import {defineComponent} from 'vue'
import VueGoogleAutocomplete from "vue-google-autocomplete";
import i18n from "@/i18n";


export default defineComponent({
  name: "AddressEdit",
  props: {
    mapId: {
      type: String,
      required: true
    }
  },
  components: {
    VueGoogleAutocomplete
  },
  data() {
    return {
      blank_address: {
        country: "France",
        countryiso2: "FR",
        exported_address: "",
        formatted_address:"",
        id: null,
        latitude:null,
        locality: null,
        longitude: null,
        postal_code: "",
        route: "",
        route2: null,
        short_postal_code: null,
        street_number:null,
      }
    }
  },
  computed: {
    establishment: {
      get() {
        const _establishment = this.$store.state.contacts.editableEstablishment;
        if (_establishment.place === null) {
          _establishment.place= this.blank_address
        }
        return _establishment;
      },
      set(value) {
        this.$store.commit("editableEstablishment", value);
      }
    },
    googleAutoCompleteKey: {
      get() {
        return this.$store.state.contacts.googleAutoCompleteKey;
      },
      set(value) {
        this.$store.commit("googleAutoCompleteKey", value);
      }
    },
    monitor() {
      return {
        renderGA: this.$store.state.contacts.renderGA
      }
    }
  },
  watch: {
    monitor: {
      handler() {
        if (!Object.values(this.monitor).includes(true)) {
          document.querySelector('.pac-container')?.remove();
        }
        this.clearGA();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onAddressChange(place) {
      const _establishment = Object.assign({}, this.establishment);
      _establishment.place = place;
      this.establishment = Object.assign({}, _establishment);
      this.clearGA();
    },
    setZindex() {
      const element = document.querySelector('.pac-container');
      if (element)
        element.style.zIndex = '1150';
    },
    clearGA() {
      this.$nextTick(() => {
        if  (this.$refs.autocomplete)
          this.$refs.autocomplete.clear();
      });
    }
  },
  beforeMount() {
    this.googleAutoCompleteKey += 1;
  }
})
</script>

<template>
  <form
      ref="form_edit_address"
      autocomplete="nope"
  >
    <b-container class="p-0">
      <!-- google place  -->
      <b-row>
        <b-col cols="12" class="position-relative">
          <b-icon icon="search" class="search-icon" />
          <vue-google-autocomplete
              v-if="$store.state.contacts.renderGA"
              id="map"
              ref="autocomplete"
              class="form-control form-control-sm search-input"
              :placeholder="$t('Rechercher une adresse')"
              :country="['fr']"
              autocomplete="nope"
              @placechanged="onAddressChange"
              @inputChange="setZindex"
          />
        </b-col>
      </b-row>
      <!-- street number & route -->
      <b-row class="mt-3 mr-2">
        <b-col cols="3">
          <b-form-input
              v-model="establishment.place.street_number"
              size="sm"
              name="street_number"
              :placeholder="$t('N°')"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="9">
          <b-form-input
              v-model="establishment.place.route"
              size="sm"
              :placeholder="$t('Adresse')"
              name="address"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
      <!-- route 2 -->
      <b-row>
        <b-col cols="12">
          <b-form-input
              v-model="establishment.place.route2"
              size="sm"
              :placeholder="$t('Adresse (suite)')"
              name="address2"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
      <!-- postal_code & locality & country -->
      <b-row class="mt-3">
        <b-col cols="4">
          <b-form-input
              v-model="establishment.place.postal_code"
              size="sm"
              :placeholder="$t('Code postal')"
              name="postal_code"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="4">
          <b-form-input
              v-model="establishment.place.locality"
              size="sm"
              :placeholder="$t('Ville')"
              name="locality"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="4">
          <b-form-input
              v-model="establishment.place.country"
              size="sm"
              :placeholder="$t('Pays')"
              name="country"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<style scoped lang="scss">
  .pac-container {
    z-index: 1050 !important;
  }

  .row {
    gap: 12px 8px;
    flex-wrap: nowrap;
    margin: 0px;
    margin-bottom: 12px;
  }

  .row > [class*="col"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .row > .col-4 {
    max-width: none !important;
    flex-basis: 0 !important;
    flex-grow: 1 !important;
  }

  .border.rounded .row {
    gap: 0;
    margin: 0;
  }

  .search-icon {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    font-size: 0.85rem;
    color: var(--secondary);
    pointer-events: none;
    z-index: 1;
  }

  .search-input {
    padding-left: 30px !important;
  }
</style>

<style lang="scss">
  .pac-target-input {
    outline: none !important;
    box-shadow: none !important;
    &:focus,
    &:focus-visible,
    &:focus-within {
      border-color: var(--black) !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
</style>